module.exports = __webpack_public_path__ + "img/15.7b2c3878.svg";